import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Zap, Download, CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function CommitmentSection() {
  return <section className="py-20 px-4 bg-brand-gray text-white relative overflow-hidden" data-id="element-1">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#C4A265 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-2"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-3">
        <div className="text-center mb-16" data-id="element-4">
          <ShieldAlert className="w-16 h-16 text-brand-gold mx-auto mb-6" data-id="element-5" />
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-cream" data-id="element-6">
            Compromiso de Calidad y Acceso Inmediato
          </h2>
          <p className="text-xl text-brand-cream/80 max-w-2xl mx-auto border-b border-brand-gold/20 pb-8" data-id="element-7">
            Debido a la naturaleza digital de este programa y al valor inmediato
            de las estrategias, protocolos y bonos descargables que recibirás en
            segundos,{' '}
            <strong className="text-brand-gold" data-id="element-8">
              todas las ventas son finales
            </strong>
            .
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-9">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 p-8 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-10">
            <Download className="w-10 h-10 text-brand-gold mb-6" data-id="element-11" />
            <h3 className="text-xl font-bold mb-4 text-brand-cream" data-id="element-12">
              Valor de Propiedad Intelectual
            </h3>
            <p className="text-brand-cream/70 leading-relaxed text-sm" data-id="element-13">
              Estás adquiriendo años de investigación biológica y nutricional
              condensada en un método de ejecución inmediata. Una vez que
              descargas el material, el conocimiento es tuyo para siempre.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white/5 p-8 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-14">
            <Zap className="w-10 h-10 text-brand-gold mb-6" data-id="element-15" />
            <h3 className="text-xl font-bold mb-4 text-brand-cream" data-id="element-16">
              Compromiso con tu Resultado
            </h3>
            <p className="text-brand-cream/70 leading-relaxed text-sm" data-id="element-17">
              Queremos trabajar con mujeres que estén 100% decididas a cambiar
              su salud hormonal. Este no es un libro para "ver si funciona", es
              un manual de transformación para quienes van a aplicar los pasos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white/5 p-8 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-18">
            <CheckCircle2 className="w-10 h-10 text-brand-gold mb-6" data-id="element-19" />
            <h3 className="text-xl font-bold mb-4 text-brand-cream" data-id="element-20">
              Soporte Total
            </h3>
            <p className="text-brand-cream/70 leading-relaxed text-sm" data-id="element-21">
              No te dejamos sola. Si tienes cualquier problema técnico para
              acceder a tus archivos o una duda específica sobre el protocolo,
              nuestro equipo técnico te responderá en menos de 24 horas.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-green p-8 md:p-12 rounded-3xl border-2 border-brand-gold relative overflow-hidden" data-id="element-22">
          {/* Shine effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full animate-[shimmer_3s_infinite]" data-id="element-23"></div>

          <div className="flex items-center gap-4 mb-6 justify-center md:justify-start" data-id="element-24">
            <span className="bg-brand-gold text-brand-gray font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-25">
              Bonificación por Acción Rápida
            </span>
          </div>

          <p className="text-lg md:text-xl text-brand-cream/90 leading-relaxed mb-8 italic" data-id="element-26">
            "Sé que este es un paso importante. Por eso, si te unes hoy, no solo
            te llevas el sistema completo y los 5 bonos, sino que te aseguras{' '}
            <strong className="text-brand-gold" data-id="element-27">
              todas las actualizaciones futuras del 'Código Hormonal 40+' de
              forma gratuita y de por vida
            </strong>
            . Inviertes una vez, transformas tu biología para siempre."
          </p>

          <CTAButton className="bg-brand-gold text-brand-gray hover:bg-white w-full max-w-lg mx-auto md:mx-0" href="https://optilatammarket.com/cart/42615614439522:1" data-id="element-28">
            SÍ, ACEPTO EL RETO HOY
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}